// A data em que tres reguas de score mudaram ao mesmo tempo.
//
// Em 10/10/2026 foram corrigidos, no mesmo dia: a zona altista do
// Confluence, cuja condicao tinha os operandos invertidos e era conjunto
// vazio (o sinal altista nunca disparou desde que o card existe); o teto
// de 55 do advanced_score, que exigia dois conflitos numa lista de um e
// portanto nunca se aplicava; e o corte do histograma do MACD na
// exaustao, que era $0,50 em dolar — 0,89% do preco da ETHA e 0,064% do
// SPY — e virou 0,9% do preco, igual para todo ativo.
//
// Leitura gravada antes desta data saiu de funcoes que nao existem mais.
// Somar as duas pontas num numero so mede duas coisas diferentes ao
// mesmo tempo, e e por isso que as leitoras de acerto dessas tres
// medidas filtram por aqui.
//
// Recalcular as antigas esta fora de alcance: a tabela analises guarda o
// score e o preco, mas nunca guardou os niveis de Fibonacci que o sinal
// lia. Nem da para saber QUAIS foram afetadas, porque o lado morto so
// mudava a nota quando o preco estava naquela faixa.
//
// oversold_score, dca_score, o resumo por tempo grafico e o oscilador
// 5/34 NAO mudaram nesta data e nao usam este corte.
export const REGUA_10_10 = "2026-10-10"

// A versao de cada regua de score, hoje. Esta e a fonte unica: os seis
// insert em analises gravam este objeto na coluna `reguas`, e as leitoras
// de acerto comparam contra ele. Mudou um score? Muda UM numero aqui, e
// tudo o mais segue sozinho — nenhuma data nova precisa ser lembrada.
//
// O historico, para quem precisar ler linha antiga:
//   confluence  1 ate 09/10/2026 · 2 de 10/10 (zona altista do Fibonacci)
//   exaustao    1 ate 09/10/2026 · 2 de 10/10 (corte do MACD: 0,9% do preco)
//   advanced    1 ate 29/09/2026 · 2 de 30/09 (OBV e Hurst) · 3 de 10/10
//                                             (o teto de 55 passou a valer)
//   oversold, dca, mtf, ew: 1 desde o inicio da tabela, em 28/08/2026.
//
// As 598 linhas que ja existiam foram preenchidas por data em 03/11/2026,
// a unica vez que a data foi usada como criterio. Daqui para a frente o
// valor vem daqui.
export const REGUAS = {
  confluence: 2,
  exaustao: 2,
  advanced: 3,
  oversold: 1,
  dca: 1,
  mtf: 1,
  ew: 1,
}

// Verdadeiro quando a linha saiu da regua ATUAL daquele score — ou seja,
// quando ela e comparavel com o que o app calcula hoje.
//
// Linha sem a coluna devolve falso, e isso e de proposito: nao saber de que
// regua veio nao e o mesmo que ser da atual, e na duvida ela fica fora da
// medicao. Como todas as 598 linhas antigas foram preenchidas em
// 03/11/2026, na pratica isso so acontece se uma consulta esquecer de
// pedir a coluna — e o patch que trouxe esta funcao confere isso em cada
// leitora antes de gravar.
export function reguaAtual(linha, score) {
  const r = linha && linha.reguas
  return !!r && r[score] === REGUAS[score]
}
